import { Component } from '@angular/core';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { CucurachaAdminService } from './service/cucuracha.service';
import { Router } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  constructor(private router: Router,private idle: Idle, private bnIdle: BnNgIdleService,private keepalive: Keepalive,private cs:CucurachaAdminService) {
      
    this.bnIdle.startWatching(1000).subscribe((res) => {
      if (res) {

        alert("Session Expired!")

        localStorage.removeItem('token')
        localStorage.removeItem('user')
  
    
        this.router.navigate(['']);
      }
    });
  }

  
}


  



